import React, { PropsWithChildren } from 'react'
import { Page } from '@/payload-types'
import { HeroBlock, Blocks } from '@/components'

interface PageMainProps extends PropsWithChildren {
  page: Page
}

function PageMain({ page, children }: Readonly<PageMainProps>) {
  return (
    <main className="flex-1 flex flex-col mt-12">
      <HeroBlock
        title={page.title}
        lead={page.lead}
        overline={page.overline}
        image={page.image}
        blockType="hero"
      />
      {children}
      {page.blocks && <Blocks blocks={page.blocks} />}
    </main>
  )
}

export { PageMain }
